// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__iQhym","label":"Section_label__1de-F","contentWrap":"Section_contentWrap__2Zzug","footer":"Section_footer__qwMdX","footerInner":"Section_footerInner__25nRl"};